import React from 'react';
import { ArrowRight } from 'lucide-react';
import { portfolio } from '../../data/mockData';

const Portfolio = () => {
  return (
    <section id="work" className="py-24 md:py-32 bg-[#f8f7f4]">
      <div className="px-6 md:px-12 lg:px-24">
        {/* Section title */}
        <div className="mb-8">
          <h2 className="text-[clamp(3rem,8vw,8rem)] font-light text-gray-300 leading-none tracking-tight">
            <span className="block">OUR</span>
            <span className="block ml-[10%]">WORK</span>
          </h2>
        </div>

        {/* Section subtitle */}
        <div className="mb-16 md:mb-24 max-w-2xl">
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-medium text-black mb-4">
            Hyper growing brands
          </h3>
          <p className="text-gray-600 leading-relaxed">
            Let's face it, first impressions matter. Your digital presence is an opportunity to wow your audience, 
            so why choose bad design? Brands win over fans when they're brave enough to go beyond their creative comfort zone.
          </p>
        </div>

        {/* Portfolio grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {portfolio.map((project, index) => (
            <a
              key={project.id}
              href="#"
              className={`group relative rounded-2xl overflow-hidden bg-gray-900 ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              <div className={`relative ${
                index === 0 ? 'aspect-[4/3]' : 'aspect-[4/3]'
              }`}>
                <img
                  src={project.image}
                  alt={project.client}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                
                {/* Content overlay */}
                <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end text-white">
                  <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <span className="text-xs text-gray-300 mb-2 block">{project.year}</span>
                    <h4 className="text-xl md:text-2xl font-medium mb-2">{project.client}</h4>
                    <p className="text-sm text-gray-300 mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {project.description}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {project.services.map((service, idx) => (
                        <span key={idx} className="text-xs px-2 py-1 bg-white/10 rounded-full">
                          {service}
                        </span>
                      ))}
                    </div>
                    <span className="text-xs uppercase tracking-wider text-gray-400">
                      {project.industry}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Portfolio;
